export const app = {
    audio: undefined,
    device: undefined,
    body: undefined,
    browser: undefined,
    components: undefined,
    cursor: undefined,
    content: undefined,
    detect: undefined,
    engine: undefined,
    language: undefined,
    loading: true,
    loader: undefined,
    mode: undefined,
    nav: undefined,
    os: undefined,
    page: undefined,
    products: undefined,
    progressiveimg: undefined,
    renderer: undefined,
    rooms: undefined,
    scroll: undefined,
    sku: undefined,
    transition: undefined,
    webp: undefined
};

export const menu = {
    current: undefined,
    isOpen: false,
};

export const modal = {
    current: undefined,
    isOpen: false,
};

export const search = {
    isActive: false,
};

export const breakpoints = {
	Desktop: 1900,
	Laptop: 1200,
	iPadLandscape: 1024,
	iPadPortrait: 768,
	iPhoneProMax: 428,
    iPhonePlus: 414,
    iPhoneSE: 320,
	iPhone: 375,
};

export const operators = {
    '<=' : 'max-width:',
    '>=' : 'min-width:',
    '≥' : 'min-width:',
    '≤' : 'max-width:', 
    '>' : 'min-width:', 
    '<' : 'max-width:',
}

export const math = {
    lerp: (a, b, n) => (1 - n) * a + n * b,
};

export const stagger = (e) => {
    e.style.display = '';
    e.style.position = '';

    const d = document.createElement('div');

    d.classList.add('line');

    e.parentNode.insertBefore(d, e);

    d.appendChild(e);
}

export const wrap = (e) => {
    e.removeAttribute('style');

    const d = document.createElement('div');
    const p = document.createElement('div');

    d.classList.add('cube');
    p.classList.add('perspective');

    e.parentNode.insertBefore(p, e);

    d.appendChild(e);
    p.appendChild(d);
}
